// Robust clipboard copy — copies the FULL text (even very long), works on
// desktop and mobile, and falls back gracefully on insecure contexts / older
// browsers where navigator.clipboard is unavailable.
export async function copyToClipboard(text) {
  const str = text == null ? "" : String(text);
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(str);
      return true;
    }
  } catch (_) {
    // fall through to legacy fallback
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = str;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    ta.style.left = "-9999px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, str.length); // iOS needs the explicit range for full selection
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (_) {
    return false;
  }
}
